<template>
  <div
    v-if="value"
    class="kvass-media-types-vimeo-thumbnail"
    :style="style"
    @click="$emit('click')"
  >
    <div class="kvass-media-types-vimeo-thumbnail__icon">
      <Icon :icon="['fab', 'vimeo']"></Icon>
    </div>
  </div>
</template>

<script>
import Icon from '@kvass/vue2-icon'

export default {
  props: {
    value: Object,
  },
  computed: {
    style() {
      let thumbnail = `/api/media/thumbnail/?url=${this.value.url}&size=small`
      return `backgroundImage: url(${thumbnail})`
    },
  },
  components: {
    Icon,
  },
}
</script>

<style lang="scss">
.kvass-media-types-vimeo-thumbnail {
  position: relative;
  height: inherit;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: center;

  &__icon {
    $size: 20px;
    width: $size;
    height: $size;
    position: absolute;
    top: -1px;
    left: -1px;
    background: #f2f2f2;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--border-radius);

    svg {
      color: #00adef;
    }
  }
}
</style>
